<template>
  <div class="nav-child-item" @click="$emit('tap', navItem)">
    <div class="nav-child-title-wrap">
      <img class="nav-icon" :src="navItem.icon" alt="" />
      <div class="nav-title">{{ navItem.title }}</div>
    </div>
    <div class="nac-child-wrap">
      <div class="nav-desc">{{ navItem.desc }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    navItem: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="less" scoped>
.nav-child-item {
  display: flex;
  flex-direction: column;
  gap: 0 16px;
  padding: 24px 24px 16px;
  cursor: pointer;

  &:hover {
    background: var(--bg-39);
    &:first-child {
      border-radius: 6px 6px 0 0;
    }
    &:last-child {
      border-radius: 0 0 6px 6px;
    }
  }

  .nav-child-title-wrap {
    display: flex;
    align-items: center;
    gap: 0 12px;
    .nav-icon {
      margin: 0;
      width: 20px;
      height: 20px;
    }

    .nav-title {
      font-size: 15px;
      font-weight: 500;
      color: var(--color-29);
      line-height: normal;
    }
  }

  .nac-child-wrap {
    margin-left: 32px;
    .nav-desc {
      margin-top: 8px;
      font-size: 12px;
      color: var(--color-27);
      line-height: normal;
    }
  }
}
</style>
